import { render, staticRenderFns } from "./AddNewPromo.vue?vue&type=template&id=646bd766"
import script from "./AddNewPromo.vue?vue&type=script&lang=js"
export * from "./AddNewPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports